import { hasLocationChanged, replace } from "./routerAdapter";

import { getLocation } from "./selectors";
import { getNewParams } from "./getNewParams";

const getLocationSnapshot = state => {
  const stateLocation = getLocation(state);

  if (
    stateLocation?.pathname !== undefined &&
    stateLocation?.search !== undefined &&
    stateLocation?.hash !== undefined
  ) {
    return stateLocation;
  }

  const browserLocation = getLocation();

  return {
    ...browserLocation,
    ...stateLocation,
    query: stateLocation?.query || browserLocation?.query
  };
};

export const buildLocationQuery = ({
  query: params,
  pathname,
  hash,
  preserve,
  currentLocation = getLocation()
}) => {
  const nextPathname = pathname || currentLocation?.pathname;
  const newParams = getNewParams({ params, preserve, currentLocation });
  delete newParams.affid;
  const { refine, q, ...rest } = newParams;
  const queryString = `${new URLSearchParams({ ...rest }).toString()}`;
  const refineString = refine
    ? `&${new URLSearchParams({ refine }).toString()}`
    : "";
  const searchQueryString = q
    ? `?q=${encodeURIComponent(q)}&${queryString}`
    : `?${queryString}`;

  const location = {
    pathname: nextPathname,
    search: `${searchQueryString}${decodeURIComponent(refineString)}`,
    query: newParams
  };

  if (hash) {
    location.hash = `#${hash}`;
  }

  return location;
};

export const updateLocationQuery = ({
  query,
  pathname,
  hash,
  preserve = true
}) => (dispatch, getState) => {
  const state = typeof getState === "function" ? getState() : undefined;
  const currentLocation = getLocationSnapshot(state);
  const nextLocation = buildLocationQuery({
    query,
    pathname,
    hash,
    preserve,
    currentLocation
  });

  if (!hasLocationChanged(currentLocation, nextLocation)) {
    return;
  }

  const replaceAction = replace(nextLocation);
  dispatch(replaceAction);

  return replaceAction;
};

export default updateLocationQuery;
